import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../../components";

interface PrescriptionFormActionsProps {
  onDiscard: () => void;
  submitButtonText: string;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const PrescriptionFormActions: React.FC<PrescriptionFormActionsProps> = ({
  onDiscard,
  submitButtonText,
  isDisabled,
  isLoading,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    navigate(location.state?.from || -1);
  };

  const handleDiscard = () => {
    onDiscard();
    handleBack();
  };
   
  return (
    <div className="flex justify-end gap-3">
      <GeneralButton
        type="button"
        title={t("discard")}
        color="lite"
        onClick={handleDiscard}
      />
      <GeneralButton
        type="submit"
        title={submitButtonText}
        color="blue"
        disabled={isDisabled}
        isLoading={isLoading}
      />
    </div>
  );
};

export default PrescriptionFormActions;
